import { Form, Input } from "antd";
import { UserOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";

const passwordRule = [
    {
        required: true,
        message: "Debe ingresar una contraseña",
    },
];

const confirmPasswordRule = [
    {
        required: true,
        message: "Debe confirmar la contraseña",
    },
    ({ getFieldValue }) => ({
        validator(_, value) {
            if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
            }
            return Promise.reject(new Error("Las constraseñas no coinciden"));
        },
    }),
];

export const loginFormItems = [
    {
        name: "cuit",
        rules: [
            {
                required: true,
                message: "Debe ingresar un CUIT",
            },
        ],
        addonBefore: <UserOutlined />,
        placeholder: "CUIT",
        component: Input,
    },
    {
        name: "password",
        rules: passwordRule,
        addonBefore: <LockOutlined />,
        placeholder: "Contraseña",
        component: Input.Password,
    },
];

export const forgotPasswordFormItems = [
    {
        name: "email",
        rules: [
            {
                required: true,
                message: "Debe ingresar un Email",
            },
            {
                pattern:
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Email inválido",
            },
        ],
        addonBefore: <MailOutlined />,
        placeholder: "ejemplo@gmail.com",
        component: Input,
    },
	{
        name: "cuit",
        rules: [
            {
                required: true,
                message: "Debe ingresar un CUIT",
            },
        ],
		addonBefore: <UserOutlined />,
        placeholder: "CUIT",
        component: Input,
    },
];

export const resetPasswordFormItems = [
    {
        name: "password",
        rules: passwordRule,
        addonBefore: <LockOutlined />,
        placeholder: "Contraseña",
        component: Input.Password,
    },
    {
        name: "confirmPassword",
        rules: confirmPasswordRule,
        addonBefore: <LockOutlined />,
        placeholder: "Confirmar Contraseña",
        component: Input.Password,
    },
];

const FormInputItem = ({ item, onChange }) => {
    const { name, rules, component: Component, ...rest } = item;

    return (
        <Form.Item name={name} rules={rules}>
            <Component {...rest} size='large' onChange={onChange} />
        </Form.Item>
    );
};

export default FormInputItem;
